// packages/components/src/homepage/hero/ChatbotBoundary.tsx
import React from 'react';

export const ChatbotBoundary: React.FC<{
  children: React.ReactNode;
  docsUrl?: string;
}> = ({ children, docsUrl }) => {
  const [hasError, setHasError] = React.useState(false);

  return (
    <ErrorCatcher onError={() => setHasError(true)}>
      {hasError ? (
        <div className="m-4 border-2 border-red-400 rounded-lg bg-red-50 text-slate-900 p-4">
          <div className="font-extrabold text-red-700 mb-1">Initialization Failed</div>
          <div className="text-sm text-red-900">
            API Client has not been configured. Call configureApiClient()
            first.
          </div>
        </div>
      ) : (
        children
      )}
    </ErrorCatcher>
  );
};

class ErrorCatcher extends React.Component<{ onError: () => void; children: React.ReactNode }> {
  componentDidCatch() {
    this.props.onError();
  }
  render() { return this.props.children as any; }
}

export default ChatbotBoundary;
